export default __webpack_public_path__ + "static/media/3341.521ea90d.png";